import React from 'react';
import DepthChart from '../components/DepthChart';
import OrdersTable from '../components/OrdersTable';
import { Helmet } from 'react-helmet';

const OrderBook = ({ buyOrders, sellOrders, midMarketPrice, osmosisPoolData, olswapData, transactions }) => {
  return (
    <>
      <Helmet>
        <title>Order Book - Libra World from 0L Network</title>
        <meta name="description" content="Explore 0Lswap order book data for the Libra token on the 0L Network. Access buy and sell orders data, track market depth, and analyze trends to inform your trading decisions." />
        <link rel="canonical" href={`https://libra-world.vercel.app/order-book`} />
      </Helmet>
      <div className="w-full my-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Libra Token Order Book</h1>
        <h2 className="text-xl text-gray-600 max-w-lg mx-auto mb-8">Explore 0Lswap order book data for the Libra token on the 0L Network.</h2>
        <DepthChart buyOrders={buyOrders} sellOrders={sellOrders} midMarketPrice={midMarketPrice} osmosisPoolData={osmosisPoolData} olswapData={olswapData} transactions={transactions} />
        <OrdersTable buyOrders={buyOrders} sellOrders={sellOrders} />
      </div>
    </>
  );
};

export default OrderBook;